<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" width="65%">
        <a-form layout="vertical" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-inputNumber style="width:100%" v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24,8]">
                <a-col :span="8">
                    <a-form-item label="财政年月" name="yearMonth">
                        <year-picker v-model:value="form.yearMonth"  />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="总资产(万元)" name="totalAssets">
                        <a-inputNumber style="width:100%" v-model:value="form.totalAssets" placeholder="请输入总资产(万元)" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="净资产" name="retainedAssets">
                        <a-inputNumber style="width:100%" v-model:value="form.retainedAssets" placeholder="请输入净资产" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="固定资产" name="fixedAssets">
                        <a-inputNumber style="width:100%" v-model:value="form.fixedAssets" placeholder="请输入固定资产" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="流动资产" name="liquidAssets">
                        <a-inputNumber style="width:100%" v-model:value="form.liquidAssets" placeholder="请输入流动资产" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="资产负债率" name="assetsLiabilityRatio">
                        <a-inputNumber style="width:100%" v-model:value="form.assetsLiabilityRatio" placeholder="请输入资产负债率" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="主营业务收入" name="mainBusinessIncome">
                        <a-inputNumber style="width:100%" v-model:value="form.mainBusinessIncome" placeholder="请输入主营业务收入" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="总负债(万元)" name="totalLiability">
                        <a-inputNumber style="width:100%" v-model:value="form.totalLiability" placeholder="请输入总负债(万元)" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="流动负债" name="liquidLiability">
                        <a-inputNumber style="width:100%" v-model:value="form.liquidLiability" placeholder="请输入流动负债" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="利润总额" name="totalProfits">
                        <a-inputNumber style="width:100%" v-model:value="form.totalProfits" placeholder="请输入利润总额" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="净利润(万元)" name="retainedProfits">
                        <a-inputNumber style="width:100%" v-model:value="form.retainedProfits" placeholder="请输入净利润(万元)" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="缴税总额" name="totalTax">
                        <a-inputNumber style="width:100%" v-model:value="form.totalTax" placeholder="请输入缴税总额" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="注册地纳税额" name="registrationPlaceTax">
                        <a-inputNumber style="width:100%" v-model:value="form.registrationPlaceTax" placeholder="请输入注册地纳税额" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="其它地区纳税额" name="otherPlaceTax">
                        <a-inputNumber style="width:100%" v-model:value="form.otherPlaceTax" placeholder="请输入其它地区纳税额" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="出口创汇" name="export">
                        <a-inputNumber style="width:100%" v-model:value="form.export" placeholder="请输入出口创汇" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="企业年度研发开发费用投入" name="development">
                        <a-inputNumber style="width:100%" v-model:value="form.development" placeholder="请输入企业年度研发开发费用投入" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="研发费占销售收入总额比例（百分比）" name="developmentRatio">
                        <a-inputNumber style="width:100%" v-model:value="form.developmentRatio" placeholder="请输入研发费占销售收入总额比例（百分比）" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="企业研发人员占职工总数比例（百分比）" name="developmentPeopleRatio">
                        <a-inputNumber style="width:100%" v-model:value="form.developmentPeopleRatio" placeholder="请输入企业研发人员占职工总数比例（百分比）" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="营业收入(万元)" name="operatingIncome">
                        <a-inputNumber style="width:100%" v-model:value="form.operatingIncome" placeholder="请输入营业收入(万元)" />
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="营业收入较上一年增长（百分比）" name="operatingIncomeGrowth">
                        <a-inputNumber style="width:100%" v-model:value="form.operatingIncomeGrowth" placeholder="请输入营业收入较上一年增长（百分比）" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="企业技术性收入和高新技术产品（服务）的销售收入之和" name="techniqueIncome">
                        <a-inputNumber style="width:100%" v-model:value="form.techniqueIncome" placeholder="请输入企业技术性收入和高新技术产品（服务）的销售收入之和" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="企业技术性收入和高新技术产品（服务）的销售收入之和占企业销售总收入		比例（百分比）" name="techniqueIncomeRatio">
                        <a-inputNumber style="width:100%" v-model:value="form.techniqueIncomeRatio" placeholder="请输入企业技术性收入和高新技术产品（服务）的销售收入之和占企业销售总收入		比例（百分比）" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="备注" name="remark">
                        <a-inputNumber style="width:100%" v-model:value="form.remark" placeholder="请输入备注" />
                    </a-form-item>
                </a-col>
                <!--可编辑区域 end-->
            </a-row>
        </a-form>

    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {financeCompanyInfo} from "@/api/finance";
import {innovation} from "@/config/variableConfig";

export default {
    name: "AddOrEditModal",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            innovation,
            form: {
                id: null,
                    companyCode: null,
                    totalAssets: null,
                    retainedAssets: null,
                    fixedAssets: null,
                    liquidAssets: null,
                    assetsLiabilityRatio: null,
                    mainBusinessIncome: null,
                    totalLiability: null,
                    liquidLiability: null,
                    totalProfits: null,
                    retainedProfits: null,
                    totalTax: null,
                    registrationPlaceTax: null,
                    otherPlaceTax: null,
                    export: null,
                    development: null,
                    developmentRatio: null,
                    techniqueIncome: null,
                    techniqueIncomeRatio: null,
                    developmentPeopleRatio: null,
                    operatingIncome: null,
                    operatingIncomeGrowth: null,
                    yearMonth: null,
                    remark: null,

            },
            rules: {
                    id: [],
                    companyCode: [],
                    totalAssets: [dataCheck.required({type:'number'})],
                    retainedAssets: [dataCheck.required({type:'number'})],
                    fixedAssets: [dataCheck.required({type:'number'})],
                    liquidAssets: [dataCheck.required({type:'number'})],
                    assetsLiabilityRatio: [dataCheck.required({type:'number'})],
                    mainBusinessIncome: [dataCheck.required({type:'number'})],
                    totalLiability: [dataCheck.required({type:'number'})],
                    liquidLiability: [dataCheck.required({type:'number'})],
                    totalProfits: [dataCheck.required({type:'number'})],
                    retainedProfits: [dataCheck.required({type:'number'})],
                    totalTax: [dataCheck.required({type:'number'})],
                    registrationPlaceTax: [dataCheck.required({type:'number'})],
                    otherPlaceTax: [dataCheck.required({type:'number'})],
                    export: [dataCheck.required({type:'number'})],
                    development: [dataCheck.required({type:'number'})],
                    developmentRatio: [dataCheck.required({type:'number'})],
                    techniqueIncome: [dataCheck.required({type:'number'})],
                    techniqueIncomeRatio: [dataCheck.required({type:'number'})],
                    developmentPeopleRatio: [dataCheck.required({type:'number'})],
                    operatingIncome: [dataCheck.required({type:'number'})],
                    operatingIncomeGrowth: [dataCheck.required({type:'number'})],
                    yearMonth: [dataCheck.required({})],
                    remark: [dataCheck.required({type:'number'})],
            },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                if (this.form.id) {
                    return financeCompanyInfo.edit
                } else {
                    return financeCompanyInfo.add
                }
            },
            postMethod() {
                if (this.form.id) {
                    return 'put'
                } else {
                    return 'post'
                }
            }
        },
    mounted() {
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>
